export enum TixGateway {
  CYBERSOURCE = 'cybersource',
  AZUL = 'azul',
}
